// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// Version token that will be replaced by the prepack command
/** The version of the SignalR client. */
export var VERSION = "1.0.4";
export { HttpError, TimeoutError } from "./Errors";
export { DefaultHttpClient, HttpClient, HttpResponse } from "./HttpClient";
export { HubConnection } from "./HubConnection";
export { HubConnectionBuilder } from "./HubConnectionBuilder";
export { MessageType } from "./IHubProtocol";
export { LogLevel } from "./ILogger";
export { HttpTransportType, TransferFormat } from "./ITransport";
export { NullLogger } from "./Loggers";
export { JsonHubProtocol } from "./JsonHubProtocol";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@aspnet/signalr/dist/esm/index.js
// module id = 272
// module chunks = 0